import styled from "@emotion/styled";
import { Box, BoxProps } from "@material-ui/core";

type DividerWithTextProps = {
  children?: React.ReactNode;
} & BoxProps;

const Container = styled(Box)`
  display: flex;
  align-items: center;
`;
const Border = styled.div`
  border-bottom: 1px solid #bdbdbd;
  flex: 1;
`;

const Content = styled.div`
  padding: 0 24px 0 24px;
  text-transform: uppercase;
  font-family: Inter, sans-serif;
  font-size: 18px;
  color: #2b33ff;
`;

export default function DividerWithText({
  children,
  ...rest
}: DividerWithTextProps) {
  return (
    <Container {...rest}>
      <Border />
      {children && <Content>{children}</Content>}
      <Border />
    </Container>
  );
}
